import { styled } from 'styled-components';
import { SlideshowBtnStyle } from '../property/SlideshowBar.style';

export const SlideshowGrid = styled.div`
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 10px;

  @media (min-width: 701px) {
    width: calc(100% - 80px);
  }
`;

export const Button = styled.button`
  ${SlideshowBtnStyle}
`;
